@use '../scss/abstracts/variables' as *;

.section {
  margin-top: 4rem;
  padding-top: 4rem;
  border-top: 1px solid rgba(43, 40, 32, 0.14);
  scroll-margin-top: 12rem;
}

.kicker {
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #bf8a2e;
  margin-bottom: 0.8rem;
}

.heading {
  font-family: 'Playfair Display', serif;
  font-size: 2.8rem;
  font-weight: 600;
  color: #2b2820;
  margin-bottom: 1rem;

  @media (max-width: $tablet-portrait) {
    font-size: 2.1rem;
  }
}

.lede {
  font-family: 'Playfair Display', serif;
  font-style: italic;
  font-size: 1.4rem;
  color: #6d6655;
  line-height: 1.6;
  margin-bottom: 2.4rem;
  max-width: 46em;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.item {
  background: #f4eee2;
  border: 1px solid #e4dccb;
  border-radius: 10px;
  padding: 0 2rem;
  transition: border-color 0.2s ease;

  &[open] {
    border-color: #bf8a2e;
  }
}

.question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;
  padding: 1rem 0;
  cursor: pointer;
  list-style: none;
  font-family: 'Playfair Display', serif;
  font-size: 1.3rem;
  font-weight: 600;
  color: #2b2820;

  &::-webkit-details-marker {
    display: none;
  }

  @media (max-width: $tablet-portrait) {
    font-size: 1.35rem;
  }
}

.icon {
  position: relative;
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border: 1px solid #ddd4c2;
  border-radius: 50%;
  background: #f4eee2;
  transition:
    transform 0.25s ease,
    border-color 0.2s ease;

  &::before,
  &::after {
    content: '';
    position: absolute;
    background: #bf8a2e;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &::before {
    width: 0.7rem;
    height: 1.5px;
  }

  &::after {
    width: 1.5px;
    height: 0.7rem;
  }

  .item[open] & {
    transform: rotate(45deg);
    border-color: #bf8a2e;
  }
}

.answer {
  padding: 0 0 2rem;
  font-family: 'Inter', sans-serif;
  font-size: 1.35rem;
  line-height: 1.75;
  color: #4a443c;

  p {
    margin: 0 0 1.2rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: #bf8a2e;
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 2px;

    &:hover {
      color: #96692a;
    }
  }

  strong,
  b {
    color: #2b2820;
    font-weight: 700;
  }

  ul,
  ol {
    padding-left: 2rem;
    margin: 0 0 1.2rem;
  }

  li {
    padding: 0.2rem 0;

    &::marker {
      color: #bf8a2e;
    }
  }
}
